namespace $ { $mol_style_attach( "exso/sheets/dashboard/dashboard.view.css",
 "[exso_sheets_app_dashboard_site_stat]::before {\n\tcontent: '';\n\tposition: absolute;\n\theight: 100%;\n\twidth: min(var(--width, 0%), 100%);\n\tbottom: 0;\n\tleft: 0;\n\tbackground-color: var(--color);\n\topacity: 10%;\n}\n"
) }